/**
 * useAI hook - AI generation operations.
 *
 * @package Schema_AI
 */

import { useState, useCallback } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

export function useAI() {
	const [ usageRemaining, setUsageRemaining ] = useState( Infinity );

	const canGenerate = useCallback( () => {
		return usageRemaining > 0;
	}, [ usageRemaining ] );

	const analyze = useCallback( async ( postId ) => {
		const result = await apiFetch( {
			path: '/ai-schema-gen/v1/analyze',
			method: 'POST',
			data: { post_id: postId },
		} );
		if ( result.usage?.remaining !== undefined ) {
			setUsageRemaining( result.usage.remaining );
		}
		return result;
	}, [] );

	const generateSchema = useCallback( async ( postId, schemaType, entities ) => {
		const data = { post_id: postId };
		if ( schemaType ) {
			data.schema_type = schemaType;
		}
		const result = await apiFetch( {
			path: '/ai-schema-gen/v1/generate',
			method: 'POST',
			data,
		} );
		if ( result.usage?.remaining !== undefined ) {
			setUsageRemaining( result.usage.remaining );
		}
		return result;
	}, [] );

	return {
		generate: { analyze, schema: generateSchema },
		canGenerate,
		usageRemaining,
	};
}

export default useAI;
